import * as React from "react";
import { Stack } from "office-ui-fabric-react";
import { IDataProvider } from "../../dataprovider/IDataProvider";
import WelcomeBackground from "./../../images/WelcomeBackground.png";
import { CompanyAccountForm } from "./CompanyAccountForm";
import "../Welcome/Welcome.scss";

export interface ICreateAccountPageProps {
  history: any;
  dataProvider: IDataProvider;
}

export const CreateAccountPage = (props: ICreateAccountPageProps): React.ReactElement => {
  return (
    <div className="welcomePageShell accountPageShell">
      <div className="welcomeBackgroundLayer" aria-hidden="true">
        <img className="welcomeBackgroundImage" src={WelcomeBackground} alt="" />
      </div>
      <div className="welcomeOverlay accountPageOverlay">
        <Stack className="accountFormPanel accountFormPanelStandalone" tokens={{ childrenGap: 18 }}>
          <CompanyAccountForm mode="register" dataProvider={props.dataProvider} onNavigateToSignIn={() => props.history.push("/")} />
        </Stack>
      </div>
    </div>
  );
};
